import Layout from "../components/Layout";
import { Link } from "react-router-dom";
import { ArrowLeft, FileText } from "lucide-react";

/**
 * Reusable shell for legal/contact pages.
 *
 * Provides:
 *  - A consistent dark sober header with breadcrumb back link.
 *  - The "draft" warning banner so the user knows the content is provisional.
 *  - A prose-style container for paragraphs / lists.
 */
export default function LegalPage({ title, kicker, lastUpdated, children, hideDraftNotice }) {
  return (
    <Layout>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10 sm:py-14">
        <Link
          to="/"
          data-testid="legal-back-link"
          className="inline-flex items-center gap-2 text-white/55 hover:text-cyan-300 text-xs font-mono-stat uppercase tracking-widest mb-6"
        >
          <ArrowLeft className="w-3.5 h-3.5" />
          Retour à l&apos;accueil
        </Link>
        <div className="flex items-center gap-2 mb-2 text-cyan-300 text-[11px] font-mono-stat uppercase tracking-[0.3em]">
          <FileText className="w-3.5 h-3.5" />
          {kicker || "Document légal"}
        </div>
        <h1 className="font-display font-black uppercase tracking-tight text-3xl sm:text-4xl mb-3">
          {title}
        </h1>
        {lastUpdated && (
          <p className="text-xs text-white/40 font-mono-stat uppercase tracking-widest mb-6">
            Dernière mise à jour : {lastUpdated}
          </p>
        )}
        {!hideDraftNotice && (
          <div
            data-testid="legal-draft-notice"
            className="mb-8 p-4 rounded-2xl border border-amber-400/40 bg-amber-400/10 text-amber-100 text-sm"
          >
            <strong className="font-display font-bold uppercase tracking-wider text-amber-200">
              Document à compléter avant lancement public.
            </strong>
            <br />
            Le contenu ci-dessous est une version de travail. Les engagements juridiques
            définitifs seront publiés ici prochainement.
          </div>
        )}
        <article className="prose prose-invert max-w-none text-white/80 leading-relaxed space-y-4 prose-headings:font-display prose-headings:tracking-tight prose-h2:text-cyan-300 prose-h2:font-black prose-h2:uppercase prose-h2:text-lg prose-h2:mt-8 prose-h2:mb-3 prose-a:text-fuchsia-300 hover:prose-a:text-fuchsia-200 prose-strong:text-white prose-ul:list-disc prose-ul:pl-6 prose-ul:my-3 prose-li:my-1">
          {children}
        </article>
      </div>
    </Layout>
  );
}
